export default __webpack_public_path__ + "static/media/Appointments.47c60a2d.svg";